import Icon from "../NGMaterialIcon/NGMaterialIcon";
import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Stack, Tooltip, Typography } from "@mui/material";
import { useSignal } from "@preact/signals-react";
import { isNull } from "lodash-es";

type MenuButtonEditorProps = {
  name: string;
  options: { Text: string; Label?: string; Icon: JSX.Element; Value: object }[];
  selectedIndex: number | null;
  onChange: (value: object) => void;
  showIcon?: boolean;
  title?: string;
  width?: string;
};

function MenuButtonEditor({
  name,
  options,
  selectedIndex,
  onChange,
  showIcon = true,
  width = "100%",
  title = "",
}: MenuButtonEditorProps) {
  const anchorEl = useSignal<HTMLElement | null>(null);
  const menuOpen = Boolean(anchorEl.value);

  const handleMenuItemClick = (e: React.MouseEvent<HTMLElement>, value: object) => {
    anchorEl.value = null;

    onChange(value);
  };

  const handleCloseMenu = () => {
    anchorEl.value = null;
  };

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    anchorEl.value = event.currentTarget;
  };

  const selectedOption = isNull(selectedIndex) ? null : options?.[Number(selectedIndex)];

  return (
    <Stack sx={{ flexDirection: "row", alignItems: "center", gap: "0.2rem", width, marginBottom: "0.35rem" }}>
      <Box component="span" sx={{ paddingRight: "0.6rem" }}>
        {showIcon && (
          <Tooltip title={title} placement="top">
            {selectedOption?.Icon || options[0].Icon}
          </Tooltip>
        )}
      </Box>

      <IconButton title={`${name}-button`} onClick={(e) => handleOpenMenu(e)} className="menu-button-prop-editor">
        <Typography>{selectedOption?.Label ?? selectedOption?.Text}</Typography>
        <Icon name="arrow_drop_down" />
      </IconButton>
      <Menu
        id={`${name}-menu`}
        anchorEl={anchorEl.value}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleCloseMenu}
        MenuListProps={{
          "aria-labelledby": "lock-button",
          role: "listbox",
        }}
      >
        {options.map(({ Value, Icon, Text }, index) => (
          <MenuItem
            key={index}
            disabled={index === selectedIndex}
            selected={index === selectedIndex}
            onClick={(event) => handleMenuItemClick(event, Value)}
          >
            <ListItemIcon>{Icon}</ListItemIcon>
            <ListItemText>{Text}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </Stack>
  );
}

export default MenuButtonEditor;
